export default function convertToCurrency(
  currency = 'usd',
  price?: number | null,
  numberOfDecimals = 2
) {
  if (!price) {
    return '-'
  }
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: numberOfDecimals,
    minimumFractionDigits: numberOfDecimals,
  }).format(price / 100)
}
